import React, { useState, useEffect } from 'react';
import {
    Background,
    Container,
    Table,
    AnexoIcon,
    Header,
    Button,
    ShowIcon,
    RemoveIcon,
    ScrollTable,
    ConfigIcon,
    ClockIcon,
    Arrow,
    AddIcon,
} from './style';
import api from '../../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../../components/GoBack';
import ModalRegister from '../../../components/Modal/Gestor/RegisterOcorrencia';
import { userId } from '../../../services/TokenData';
import ModalEdit from '../../../components/Modal/EditOcorrencia';
import { TruncateString } from '../../../services/TruncateString';
import { Swal } from '../../../services/SwalTemplates';
import { format } from '../../../services/DateFormatter';
import ModalEditProcess from '../../../components/Modal/SolicitacaoTempoProcesso';
import ModalTime from '../../../components/Modal/SolicitacaoTempo';
import alert from '../../../utils/alert';

export default function Processo() {
    const [Dados, setDados] = useState([]);
    const [ShowModalRegister, setShowModalRegister] = useState(false);
    const [ShowModalEdit, setShowModalEdit] = useState(false);
    const [ShowModalClock, setShowModalClock] = useState(false);
    const [Ocorrencia, setOcorrencia] = useState(null);
    const [Reload, setReload] = useState(false);
    const Location = useLocation();
    const Navigate = useNavigate();
    const UserId = userId();
    const [ShowModalEditProcess, setShowModalEditProcess] = useState(false);
    const [Processo, setProcesso] = useState(null);
    const [expandedRow, setExpandedRow] = useState();
    const [changeColorRow, setChangeColorRow] = useState();
    const [sequencia, setSequencia] = useState(null);
    const [getSubOcorrencias, setGetSubOcorrencias] = useState(null);
    const [subOcorrencias, setSubOcorrencias] = useState([]);

    useEffect(() => {
        const locationSeqOcorrencia = Location?.state?.seq_ocorrencia;
        api.get(`/processos/${Location?.state?.IdOcorrencia}/ocorrencias`).then((response) => {
            setDados(response.data.processos);
            const indexRow = response.data.processos?.ocorrencias?.findIndex((o) => o.seq_ocorrencia === locationSeqOcorrencia);
            if (!!locationSeqOcorrencia) {
                setExpandedRow(indexRow);
                setChangeColorRow(locationSeqOcorrencia);
            }
        });

        setTimeout(() => {
            setChangeColorRow();
        }, 5000);
    }, [Location?.state?.IdOcorrencia, Reload]);

    //Não é possível deletar pois nível_ocorrencia ainda não foi completado
    function deletaOcorrencia(id_processo, seq_ocorrencia, nivel_ocorrencia) {
        Swal.fire({
            title: `Deseja excluir a ${nivel_ocorrencia === 0 ? 'ocorrência' : 'subocorrência'} ${seq_ocorrencia}${nivel_ocorrencia !== 0 ? `.${nivel_ocorrencia}` : ''}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'var(--deep-carmine-pink)',
            cancelButtonColor: 'gray',
            cancelButtonText: 'CANCELAR',
            confirmButtonText: 'DELETAR',
            customClass: {
                icon: 'custom-icon-color',
            },
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/ocorrencias/${id_processo}/${seq_ocorrencia}/${nivel_ocorrencia}`, {
                    data: { id_usuario_acao: userId() },
                })
                    .then((res) => {
                        alert(
                            'Sucesso-popup',
                            `${nivel_ocorrencia === 0 ? 'Ocorrência' : 'Subocorrência'} deletada com sucesso!`,
                            3000,
                            '',
                            '',
                            'top-end',
                            'fit-content'
                        );
                        setReload(!Reload);
                    })
                    .catch((e) => {
                        alert(
                            'Erro-popup',
                            `Erro ao deletar ${nivel_ocorrencia === 0 ? 'ocorrência' : 'subocorrência'}!`,
                            3000,
                            '',
                            '',
                            'top-end',
                            'fit-content'
                        );
                        console.error(e);
                    });
            }
        });
    }

    function diffInDays(dataInicial, dataFinal) {
        const parseDate = (dateStr) => {
            const parts = dateStr.split('/').map(Number);
            return new Date(parts[2], parts[1] - 1, parts[0]);
        };

        const inicial = typeof dataInicial === 'string' ? parseDate(dataInicial) : dataInicial;
        const final = typeof dataFinal === 'string' ? parseDate(dataFinal) : dataFinal;

        const diffTime = final - inicial;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    function formatarData(options) {
        const { DataInicial, Formato } = options;
        const data = DataInicial;

        if (Formato === 'DD/MM/YYYY') {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            return `${dia}/${mes}/${ano}`;
        }

        return data.toISOString().split('T')[0];
    }

    function AlertaCor(dados) {
        if (!dados) {
            return '';
        }
        const hoje = new Date();

        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const parts = dateStr.split('/').map(Number);
            return new Date(parts[2], parts[1] - 1, parts[0]);
        };

        const dataPrevista = parseDate(dados.data_prevista);
        const dataConclusao = parseDate(dados.data_conclusao);

        // Se a situação é "Concluído"
        if (dados.situacao === 'Concluído') {
            if (dataConclusao && dataPrevista) {
                const diasConclusao = diffInDays(dados.data_prevista, dados.data_conclusao);
                return diasConclusao >= 0 ? 'G' : 'O';
            }
            return '';
        }

        // Para tarefas não concluídas
        if (!dataPrevista) {
            return '';
        }

        const diasPrevistos = diffInDays(dados.data_emissao, dados.data_prevista);
        const hojeFormatado = formatarData({ DataInicial: hoje, Formato: 'DD/MM/YYYY' });
        const diasRestantes = diffInDays(hojeFormatado, dados.data_prevista);

        // Prazo vencido
        if (diasRestantes <= 0) {
            return 'R';
        }

        const limite10 = Math.ceil(diasPrevistos * 0.1);
        let limite20 = Math.ceil(diasPrevistos * 0.2);

        if (limite20 < 2) {
            limite20 = 2;
        }

        // Verificar alertas
        if (diasRestantes <= limite10 && diasRestantes >= 1) {
            return 'R';
        } else if (diasRestantes <= limite20 && diasRestantes >= 2) {
            return 'Y';
        }
        return '';
    }

    const handleClickExpandedRow = (index, seq_ocorrencia) => {
        if (index === expandedRow) {
            setExpandedRow();
            setGetSubOcorrencias(null);
        } else {
            setExpandedRow(index);
            setGetSubOcorrencias(seq_ocorrencia);
        }
    };

    const getSubOcorrenciaAPI = async () => {
        try {
            const res = await api.get(`/processos/${Location?.state?.IdOcorrencia}/ocorrencias/${getSubOcorrencias}`);
            setSubOcorrencias(res.data.subocorrencias);
        } catch (e) {
            console.error(e);
        }
    };

    const handleClickEdit = (dataPrevista, dados) => {
        let dataMaximaParaAtribuicao = null;

        if (dataPrevista?.includes('/')) {
            // Formato brasileiro: dd/mm/yyyy
            const [dia, mes, ano] = dataPrevista.split('/');
            const dataObj = new Date(ano, mes - 1, dia);
            dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
        } else if (dataPrevista) {
            // Formato ISO ou outra string de data válida
            const dataObj = new Date(dataPrevista);
            if (!isNaN(dataObj)) {
                dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
            }
        }

        const data = {
            ...dados,
            dataPrevista: dataMaximaParaAtribuicao,
        };

        setOcorrencia(data);
        setShowModalEdit(true);
    };

    const handleClickAdd = (dados) => {
        let dataMaximaParaAtribuicao = null;
        if (dados?.data_prevista?.includes('/')) {
            // Formato brasileiro: dd/mm/yyyy
            const [dia, mes, ano] = dados?.data_prevista?.split('/');
            const dataObj = new Date(ano, mes - 1, dia);
            dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
        } else if (dados?.data_prevista) {
            // Formato ISO ou outra string de data válida
            const dataObj = new Date(dados?.data_prevista);
            if (!isNaN(dataObj)) {
                dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
            }
        }
        const data = {
            ...dados,
            data_prevista: dataMaximaParaAtribuicao,
        };
        setSequencia(data);
        setShowModalRegister(true);
    };

    useEffect(() => {
        if (!getSubOcorrencias) return;

        getSubOcorrenciaAPI();
    }, [getSubOcorrencias, Reload]);

    return (
        <Background>
            <GoBack />
            <Container>
                <Header>
                    <Button onClick={() => setShowModalRegister(true)}>Novo</Button>
                    <h1>Lista de Ocorrências</h1>
                    <div style={{ width: '150px' }}>
                        <span></span>
                    </div>
                </Header>
                <ScrollTable>
                    <Table className="info">
                        <tbody>
                            <tr>
                                <th style={{ width: '14%' }}>Processo Nº : {Dados?.numero}</th>
                                <th>Assunto: {Dados?.assunto}</th>
                                <th style={{ width: '5%' }}>
                                    <ConfigIcon
                                        onClick={() => {
                                            setProcesso(Dados);
                                            setShowModalEditProcess(true);
                                        }}
                                    />
                                </th>
                            </tr>
                        </tbody>
                    </Table>
                </ScrollTable>
                <ScrollTable>
                    <Table>
                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: 'var(--table-primary-color)',
                                width: '100%',
                                border: '2px solid white',
                            }}
                        >
                            <tr>
                                <th></th>
                                <th>Seq.</th>
                                <th>Remetente</th>
                                <th>Destinatário</th>
                                <th>Descrição</th>
                                <th>Data Inicial</th>
                                <th>Data Prevista</th>
                                <th>Data Conclusão</th>
                                <th>Situação</th>
                                <th>Dias Restantes</th>
                                <th>Anexos</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Dados?.ocorrencias?.map((d, i) => (
                                <React.Fragment key={i}>
                                    <tr
                                        style={{
                                            backgroundColor: changeColorRow === d?.seq_ocorrencia ? '#ff2152' : '',
                                            transition: changeColorRow === d?.seq_ocorrencia ? '' : 'background-color 1s',
                                        }}
                                    >
                                        <td onClick={() => handleClickExpandedRow(i, d.seq_ocorrencia)} style={{ width: 'fit-content' }}>
                                            <Arrow expandedRow={expandedRow === i} />
                                        </td>
                                        <td className={AlertaCor(d)}>{d?.seq_ocorrencia}</td>
                                        <td title={d?.nome_remetente}>{TruncateString(d?.nome_remetente, 12)}</td>
                                        <td title={d?.nome_destinatario}>{TruncateString(d?.nome_destinatario, 20)}</td>
                                        <td title={d?.descricao}>{TruncateString(d?.descricao, 12)}</td>
                                        <td>{d?.data_emissao}</td>
                                        <td>{d?.data_prevista}</td>
                                        <td>{d?.data_conclusao || '-'}</td>
                                        <td className={AlertaCor(d)}>{d?.situacao}</td>
                                        <td className={AlertaCor(d)}>
                                            {d?.situacao === 'Concluído'
                                                ? '-'
                                                : diffInDays(format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }), d?.data_prevista) < 0
                                                  ? 0
                                                  : diffInDays(format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }), d?.data_prevista)}
                                        </td>
                                        <td>
                                            {!d?.anexos || (
                                                <AnexoIcon
                                                    title="Ver Anexos"
                                                    onClick={() =>
                                                        Navigate('/gestor/anexos', {
                                                            state: {
                                                                NumProcesso: Dados?.numero,
                                                                IdProcesso: Dados?.id,
                                                                Seq: d?.seq_ocorrencia,
                                                                Desc: d?.descricao,
                                                            },
                                                        })
                                                    }
                                                />
                                            )}
                                        </td>
                                        <td>
                                            {(UserId === d?.id_destinatario || UserId === d?.id_remetente) && (
                                                <ShowIcon title="Visualizar" onClick={() => handleClickEdit(Dados?.data_prevista, d)} />
                                            )}
                                        </td>
                                        <td>
                                            {d?.id_destinatario === UserId && (
                                                <ClockIcon
                                                    title="Solicitar Prorrogação de Prazo?"
                                                    onClick={() => {
                                                        setOcorrencia(d);
                                                        setShowModalClock(true);
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            {UserId === d?.id_remetente && (
                                                <RemoveIcon
                                                    title="Excluir"
                                                    onClick={() => {
                                                        deletaOcorrencia(Dados?.id, d?.seq_ocorrencia, d?.nivel_ocorrencia);
                                                    }}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    {expandedRow === i && subOcorrencias?.length > 0 ? (
                                        <>
                                            {subOcorrencias?.map((sub) => (
                                                <tr>
                                                    <td></td>
                                                    <td className={AlertaCor(sub)}>
                                                        {sub?.seq_ocorrencia}
                                                        {'.'}
                                                        {sub?.nivel_ocorrencia}
                                                    </td>
                                                    <td>{sub?.nome_remetente}</td>
                                                    <td>{sub?.nome_destinatario}</td>
                                                    <td>{sub?.descricao}</td>
                                                    <td>{sub?.data_emissao}</td>
                                                    <td>{sub?.data_prevista}</td>
                                                    <td>{sub?.data_conclusao}</td>
                                                    <td className={AlertaCor(sub)}>{sub?.situacao}</td>
                                                    <td className={AlertaCor(sub)}>
                                                        {sub?.situacao === 'Concluído'
                                                            ? '-'
                                                            : diffInDays(
                                                                    format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }),
                                                                    sub?.data_prevista
                                                                ) < 0
                                                              ? 0
                                                              : diffInDays(
                                                                    format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }),
                                                                    sub?.data_prevista
                                                                )}
                                                    </td>

                                                    <td>
                                                        {!sub?.anexos || (
                                                            <AnexoIcon
                                                                title="Ver Anexos"
                                                                onClick={() =>
                                                                    Navigate('/gestor/anexos', {
                                                                        state: {
                                                                            NumProcesso: Dados?.numero,
                                                                            IdProcesso: Dados?.id,
                                                                            Seq: d?.seq_ocorrencia,
                                                                            Nivel: sub?.nivel_ocorrencia,
                                                                            Desc: d?.descricao,
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        )}
                                                    </td>

                                                    <td></td>

                                                    <td>
                                                        {(UserId === sub?.id_remetente || UserId === sub?.id_destinatario) && (
                                                            <ShowIcon onClick={() => handleClickEdit(d?.data_prevista, sub)} />
                                                        )}
                                                    </td>

                                                    <td>
                                                        {UserId === sub?.id_destinatario && (
                                                            <ClockIcon
                                                                onClick={() => {
                                                                    setOcorrencia(sub);
                                                                    setShowModalClock(true);
                                                                }}
                                                            />
                                                        )}
                                                    </td>

                                                    <td>
                                                        {UserId === sub?.id_remetente && (
                                                            <RemoveIcon
                                                                title="Excluir"
                                                                onClick={() => {
                                                                    deletaOcorrencia(Dados?.id, sub?.seq_ocorrencia, sub?.nivel_ocorrencia);
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        expandedRow === i && (
                                            <>
                                                <tr style={{ border: 'none' }}>
                                                    <td colSpan={14}></td>
                                                </tr>
                                                <tr style={{ borderBottom: 'none', borderTop: 'none' }}>
                                                    <td colSpan={16} style={{ textAlign: 'center', fontWeight: 600 }}>
                                                        Nenhuma subocorrência encontrada.
                                                    </td>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <td colSpan={14}></td>
                                                </tr>
                                            </>
                                        )
                                    )}
                                    {expandedRow === i && (
                                        <>
                                            <tr>
                                                <td colSpan={15} style={{ textAlign: 'center', padding: '10px' }}>
                                                    <Button
                                                        style={{
                                                            backgroundColor: 'green',
                                                            fontWeight: '700',
                                                            padding: '2px 10px',
                                                            textTransform: 'none',
                                                        }}
                                                        onClick={() => handleClickAdd(d)}
                                                    >
                                                        <div>
                                                            <AddIcon size={21} />
                                                            <p>Adicionar</p>
                                                        </div>
                                                    </Button>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                    {expandedRow === i && (
                                        <tr style={{ border: 'none', backgroundColor: '#98C1D97F' }}>
                                            <td colSpan={16}></td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </ScrollTable>

                <span className="legenda">
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--alerta-vermelho-color)',
                                color: 'var(--alerta-vermelho-color)',
                            }}
                        >
                            ______
                        </div>
                        <p>Atenção</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--alerta-amarelo-color)',
                                color: 'var(--alerta-amarelo-color)',
                            }}
                        >
                            ______
                        </div>
                        <p>Alerta</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--sandy-brown)',
                                color: 'var(--sandy-brown)',
                            }}
                        >
                            ______
                        </div>
                        <p>Concluído com atraso</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--pastel-green)',
                                color: 'var(--pastel-green)',
                            }}
                        >
                            ______
                        </div>
                        <p>Concluído no prazo</p>
                    </div>
                </span>
            </Container>
            <ModalRegister
                Show={ShowModalRegister}
                setShow={setShowModalRegister}
                NumProcesso={Dados?.numero}
                IdProcesso={Location?.state?.IdOcorrencia}
                setReload={setReload}
                Dados={Dados}
                sequencia={sequencia}
                setSequencia={setSequencia}
                Reload={Reload}
            />
            <ModalEdit
                Show={ShowModalEdit}
                setShow={setShowModalEdit}
                Reload={Reload}
                setReload={setReload}
                DadosOcorrencia={Ocorrencia}
                DadosProcesso={Dados}
            />
            <ModalTime
                Show={ShowModalClock}
                setShow={setShowModalClock}
                Reload={Reload}
                setReload={setReload}
                DadosOcorrencia={Ocorrencia}
                DadosProcesso={Dados}
            />
            <ModalEditProcess
                Show={ShowModalEditProcess}
                Reload={Reload}
                setShow={setShowModalEditProcess}
                setReload={setReload}
                Dados={Dados}
                IdResponsavel={Location?.state?.IdResponsavel}
            />
        </Background>
    );
}
